// extracted by mini-css-extract-plugin
export default {"Text__review":"BusinessCard_Text__review__ypzC-"};